import { Injectable } from '@angular/core';

import { ApiService } from '@app/services';
import { LoggedUserConfiguration } from '@app/models';

@Injectable({
  providedIn: 'root'
})
export class LoggedUserConfigurationService {

    constructor(
        private apiService: ApiService
    ) {}
    
    async getLoggedUserConfiguration(operationId: number): Promise<LoggedUserConfiguration> {
        let loggedUserConfiguration: LoggedUserConfiguration = new LoggedUserConfiguration();
        let params = {
            ctxId: operationId
        }
        let response = await this.apiService.get('pearlsconfig/loggeduserconfiguration', params);
        if(response?.data){
            loggedUserConfiguration = LoggedUserConfiguration.FromJson(response.data);
        }
        return loggedUserConfiguration;
    }
      
}
